export class HtmlUtils {
  public static addMultipleEventListeners(element: HTMLElement, events: string[], eventListener: EventListenerOrEventListenerObject, options?: boolean | AddEventListenerOptions) {
    for (const ev of events) {
      element.addEventListener(ev, eventListener, options);
    }
  }
}